import axios from '@/config/httpConfig'


export function getList(search) {
    return axios.get('/agreement_record/department/list',{params:search})
}

export function getDownload(su_numbers) {
    return axios.post('/agreement_record/department/bulk_downloadagreement',su_numbers)
}